export function emptyEvents() {
  return {};
}
